export class CommonUtil {
    public static isEmpty(object: any): boolean {
        return object === undefined || object === null || object === '';
    }
}
